import { gql } from '@apollo/client';

export const GET_BUSINESS_BY_ID = gql`
  query GetBusinessById($id: Int!) {
    getBusinessById(id: $id, showAll: true) {
      name
      timeZone
      businessApprovalStatus {
        status
      }
      businessCategory {
        name
        features {
          couponAllowed
          googleReserveAllowed
          campaignZipcodeAllowed
        }
      }
      businessSubLevels {
        id
      }
      conversationsSummary {
        unreadCount
      }
      businessPermissions {
        isAdmin
        isAssociate
      }
      businessSubscription {
        subscriptionPlan {
          subscriptionTierType
          features {
            advanceAppointmentAllowed
            basicAppointmentAllowed
            campaignAllowed
            dedicatedNumberMessagingAllowed
            consoleApplicationAllowed
            googleFormAllowed
            genericNumberMessagingAllowed
            googleReserveAllowed
            reviewResponseAllowed
          }
          name
        }
      }
    }
  }
`;

export const GET_TINYMCE_KEY = gql`
  query GetTinyMCEPublicKey {
    getTinyMCEPublicKey
}`;

export const GET_BUSINESS_POS_ORDERS_UNPAID = gql`
  mutation GetBusinessPosOrdersUnpaid($filterInput: UserPosOrderFilterInput!) {
    getBusinessPosOrders(filterInput: $filterInput) {
      isSuccess
      errorMessage
      orders {
        status
      }
    }
  }
`;

export const GET_BUSINESS_CAMPAIGNS = gql`
  query GetBusinessCampaigns($selectCampaignsInput: SelectCampaignsInput!) {
    getCampaigns(selectCampaignsInput: $selectCampaignsInput) {
      campaigns {
        status
      }
    }
  }
`;